import { Component, DestroyRef, ElementRef, HostBinding, HostListener, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { VexLayoutService } from '@vex/services/vex-layout.service';
import { VexConfigService } from '@vex/config/vex-config.service';
import { filter, map, startWith, switchMap } from 'rxjs/operators';
import { NavigationService } from '../../../core/navigation/navigation.service';
import { VexPopoverService } from '@vex/components/vex-popover/vex-popover.service';
import { MegaMenuComponent } from './mega-menu/mega-menu.component';
import { Observable, of } from 'rxjs';
import { NavigationComponent } from '../navigation/navigation.component';
import { ToolbarUserComponent } from './toolbar-user/toolbar-user.component';
import { ToolbarNotificationsComponent } from './toolbar-notifications/toolbar-notifications.component';
import { NavigationItemComponent } from '../navigation/navigation-item/navigation-item.component';
import { MatMenuModule } from '@angular/material/menu';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NavigationItem } from '../../../core/navigation/navigation-item.interface';
import { checkRouterChildsData } from '@vex/utils/check-router-childs-data';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoginService } from 'src/app/core/authentication';
import { parseJSON } from 'date-fns';
import { fadeInUp400ms } from '@vex/animations/fade-in-up.animation';
import { scaleIn400ms } from '@vex/animations/scale-in.animation';
import { fadeInRight400ms } from '@vex/animations/fade-in-right.animation';
import { FullscreenService } from 'src/app/lib/services/fullscreen.service';
import { MatDialog } from '@angular/material/dialog';
import { todateComponent } from 'src/app/lib/ctrls/components/todate.component';
import moment from 'moment';

@Component({
  selector: 'vex-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  standalone: true,
  animations: [fadeInRight400ms, scaleIn400ms],
  imports: [MatButtonModule, MatIconModule, NgIf, RouterLink, MatMenuModule, NgFor, NavigationItemComponent, ToolbarUserComponent, NavigationComponent, AsyncPipe]
})
export class ToolbarComponent implements OnInit {
  @HostBinding('class.shadow-b')
  showShadow: boolean = false;

  navigationItems$: Observable<NavigationItem[]> = this.navigationService.items$;

  isHorizontalLayout$: Observable<boolean> = this.configService.config$.pipe(map((config) => config.layout === 'horizontal'));
  isVerticalLayout$: Observable<boolean> = this.configService.config$.pipe(map((config) => config.layout === 'vertical'));
  isNavbarInToolbar$: Observable<boolean> = this.configService.config$.pipe(map((config) => config.navbar.position === 'in-toolbar'));
  isNavbarBelowToolbar$: Observable<boolean> = this.configService.config$.pipe(map((config) => config.navbar.position === 'below-toolbar'));
  userVisible$: Observable<boolean> = this.configService.config$.pipe(map((config) => config.toolbar.user.visible));
  title$: Observable<string> = this.configService.select((config) => config.sidenav.title);
  companyname: any = '';
  isDesktop$: Observable<boolean> = this.layoutService.isDesktop$;
  isMobile$: Observable<boolean> = this.layoutService.isMobile$;
  ltMd$: Observable<boolean> = this.layoutService.ltMd$;
  megaMenuOpen$: Observable<boolean> = of(false);
  private readonly destroyRef: DestroyRef = inject(DestroyRef);

  constructor(
    private readonly layoutService: VexLayoutService,
    private readonly configService: VexConfigService,
    private readonly navigationService: NavigationService,
    private readonly popoverService: VexPopoverService,
    private readonly router: Router,
    private fullscreenService: FullscreenService,
    private loginservice: LoginService,
    private dialog: MatDialog
  ) {}
  cinfo: any;
  ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        startWith(null),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.showShadow = checkRouterChildsData(this.router.routerState.root.snapshot, (data) => data.toolbarShadowEnabled ?? false);
      });
    this.fullscreenService.isFullscreen$.subscribe((state) => {
      this.isFullscreen = state;
    });
    this.cinfo = this.loginservice.getCompanyInfo();
    this.companyname = this.propercase(this.cinfo.cname);
  }
  propercase(val: string) {
    return val.replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
  openQuickpanel(): void {
    this.layoutService.openQuickpanel();
  }

  openSidenav(): void {
    this.layoutService.openSidenav();
  }

  openMegaMenu(origin: ElementRef | HTMLElement): void {
    this.megaMenuOpen$ = of(
      this.popoverService.open({
        content: MegaMenuComponent,
        origin,
        offsetY: 12,
        position: [
          {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top'
          },
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top'
          }
        ]
      })
    ).pipe(
      switchMap((popoverRef) => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true)
    );
  }
  isFullscreen: boolean = false;
  toggleFullscreen() {
    const doc: any = document;
    const docEl: any = document.documentElement;

    if (!doc.fullscreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
      if (docEl.requestFullscreen) {
        docEl.requestFullscreen();
      } else if (docEl.webkitRequestFullscreen) {
        docEl.webkitRequestFullscreen();
      } else if (docEl.msRequestFullscreen) {
        docEl.msRequestFullscreen();
      }
    } else {
      if (doc.exitFullscreen) {
        doc.exitFullscreen();
      } else if (doc.webkitExitFullscreen) {
        doc.webkitExitFullscreen();
      } else if (doc.msExitFullscreen) {
        doc.msExitFullscreen();
      }
    }
  }
  datechange() {
    this.dialog
      .open(todateComponent, {
        disableClose: true,
        data: {
          fdt: this.cinfo?.fdt ? moment(this.cinfo.fdt, 'DD-MM-YYYY').toDate() : null,

          tdt: this.cinfo?.tdt ? moment(this.cinfo.tdt, 'DD-MM-YYYY').toDate() : null
        }
      })
      .afterClosed()
      .subscribe((res: any) => {
        if (res.rs == 'yes') {
          const updated = {
            ...this.cinfo,
            fdt: res.fdt ? moment(res.fdt).format('DD-MM-YYYY') : null,
            tdt: res.tdt ? moment(res.tdt).format('DD-MM-YYYY') : null
          };

          localStorage.setItem('cmpinfo', JSON.stringify(updated));
          this.cinfo = updated;
        }
      });
  }
  @HostListener('document:fullscreenchange')
  @HostListener('document:webkitfullscreenchange')
  @HostListener('document:mozfullscreenchange')
  @HostListener('document:MSFullscreenChange')
  onFullScreenChange() {
    const doc: any = document;
    this.isFullscreen = !!(doc.fullscreenElement || doc.webkitFullscreenElement || doc.msFullscreenElement);
  }
  openSearch(): void {
    this.layoutService.openSearch();
  }
}
